var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationOn = function SvgLocationOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "location_on_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#location_on_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 11.5q.625 0 1.062-.438.438-.437.438-1.062t-.438-1.062A1.44 1.44 0 0 0 12 8.5q-.625 0-1.062.438A1.44 1.44 0 0 0 10.5 10q0 .625.438 1.062.437.438 1.062.438m0 8.75q3.125-2.725 4.812-5.45t1.688-4.6q0-2.95-1.887-4.825T12 3.5 7.388 5.375Q5.5 7.25 5.5 10.2q0 1.875 1.688 4.6T12 20.25m0 1.05a.95.95 0 0 1-.575-.2q-3.5-3.2-5.212-5.95Q4.5 12.4 4.5 10.2q0-3.524 2.263-5.612T12 2.5t5.238 2.088Q19.5 6.675 19.5 10.2q0 2.2-1.712 4.95-1.713 2.75-5.213 5.95a.6.6 0 0 1-.263.15q-.162.05-.312.05"
  }))));
};
export default SvgLocationOn;